export default "__VITE_ASSET__DGVD0fOM__"